package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import one.healthium.uscreen.domain.models.StackBlock
import one.healthium.uscreen.ui.UScreenAnswer
import one.healthium.uscreen.ui.UScreenCallbacks
import one.healthium.uscreen.ui.util.uscreenPadding

@Composable
fun UScreenStackBlock(
    modifier: Modifier = Modifier,
    block: StackBlock,
    answers: Map<String, UScreenAnswer>,
    isMale: Boolean?,
    placeholders: Map<String, String>,
    callbacks: UScreenCallbacks,
) {
    val alignment = when (block.contentAlignment) {
        "top_start" -> Alignment.TopStart
        "top_center", "top" -> Alignment.TopCenter
        "top_end" -> Alignment.TopEnd
        "center_start" -> Alignment.CenterStart
        "center" -> Alignment.Center
        "center_end" -> Alignment.CenterEnd
        "bottom_start" -> Alignment.BottomStart
        "bottom_center", "bottom" -> Alignment.BottomCenter
        "bottom_end" -> Alignment.BottomEnd
        else -> Alignment.Center
    }

    Box(
        modifier = modifier
            .fillMaxWidth()
            .uscreenPadding(block.padding, defaultHorizontal = 0)
            .testTag("uscreen_stack"),
        contentAlignment = alignment,
    ) {
        block.blocks.forEachIndexed { index, childBlock ->
            // First child (background) fills the Box, subsequent children use matchParentSize
            val childModifier = if (index == 0) {
                Modifier.fillMaxWidth()
            } else {
                Modifier.matchParentSize()
            }
            Column(
                modifier = childModifier,
                verticalArrangement = if (index > 0) Arrangement.Center else Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                UScreenBlockRenderer(
                    block = childBlock,
                    answers = answers,
                    isMale = isMale,
                    placeholders = placeholders,
                    callbacks = callbacks,
                )
            }
        }
    }
}
